import { Outlet } from 'react-router-dom';
import { Lock, ShieldCheck, FileCheck2, TrendingUp } from 'lucide-react';

// Marca desta app: compliance trabalhista/previdenciário/SST (porte React do tax-tech).
const BRAND = 'Compliance';

const FEATURES = [
  {
    icon: ShieldCheck,
    title: 'Segurança de ponta',
    desc: 'Seus dados protegidos com criptografia e monitoramento contínuo.',
  },
  {
    icon: FileCheck2,
    title: 'Conformidade garantida',
    desc: 'Sempre atualizado com a legislação trabalhista e fiscal.',
  },
  {
    icon: TrendingUp,
    title: 'Mais produtividade',
    desc: 'Automação de processos que libera tempo para o que realmente importa.',
  },
];

/**
 * Layout de tela dividida das rotas de autenticação (login, recuperar senha):
 * painel de marca à esquerda + card do formulário (via <Outlet />) à direita.
 */
export default function LayoutAuthSplit() {
  return (
    <div className="flex min-h-screen w-full flex-col lg:h-screen lg:min-h-0 lg:flex-row lg:overflow-hidden">
      {/* ── Painel esquerdo (marca) ─────────────────────────────── */}
      <aside className="relative hidden bg-gradient-to-b from-[#2b1c66] via-[#33236f] to-[#221650] px-10 py-10 text-white lg:flex lg:w-1/2 lg:flex-col lg:overflow-y-auto xl:px-16">
        {/* logo branco nítido: usa o alpha do PNG como máscara preenchida de branco */}
        <span
          role="img"
          aria-label="Agnes"
          className="block h-8 w-[106px] bg-white"
          style={{
            WebkitMaskImage: 'url(/assets/logo.png)',
            maskImage: 'url(/assets/logo.png)',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskSize: 'contain',
            maskSize: 'contain',
            WebkitMaskPosition: 'left center',
            maskPosition: 'left center',
          }}
        />

        <div className="mt-8">
          <h1 className="text-5xl font-bold tracking-tight">{BRAND}</h1>
          <p className="mt-4 max-w-md text-lg font-light leading-snug text-white/85">
            Plataforma de compliance trabalhista,
            <br />
            previdenciário e SST do eSocial.
          </p>
          <div className="mt-5 h-1 w-16 rounded-full bg-teal-400" />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-white/70">
            Solução completa para empresas que buscam eficiência, segurança e regularidade com
            eSocial e compliance com demais Órgãos Públicos.
          </p>
        </div>

        <ul className="mt-10 mb-8 space-y-6">
          {FEATURES.map(({ icon: Icon, title, desc }) => (
            <li key={title} className="flex gap-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-teal-300">
                <Icon className="h-5 w-5" />
              </span>
              <div>
                <p className="font-semibold">{title}</p>
                <p className="text-sm text-white/70">{desc}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="mt-auto rounded-2xl bg-white/5 p-5 ring-1 ring-white/10">
          <p className="flex items-center gap-2 font-semibold">
            <Lock className="h-4 w-4 text-teal-300" /> Ambiente seguro
          </p>
          <p className="mt-1 max-w-md text-sm text-white/70">
            Seus dados são protegidos com criptografia de ponta a ponta e em conformidade com a
            LGPD.
          </p>
        </div>
      </aside>

      {/* ── Painel direito (formulário via Outlet) ──────────────── */}
      <main className="flex flex-1 flex-col bg-agnes-bg-default px-6 py-10 sm:px-10 lg:overflow-y-auto">
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md rounded-2xl border border-agnes-border bg-agnes-bg-surface p-8 shadow-agnes-card">
            <Outlet />
          </div>
        </div>

        <footer className="mt-8 text-center text-sm text-agnes-text-muted">
          <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <a href="#" className="hover:text-agnes-text-primary">
              Política de privacidade
            </a>
            <span className="text-agnes-border">|</span>
            <a href="#" className="hover:text-agnes-text-primary">
              Termos de uso
            </a>
            <span className="text-agnes-border">|</span>
            <a href="#" className="hover:text-agnes-text-primary">
              Política de segurança
            </a>
          </nav>
          <p className="mt-2 text-xs">© 2026 Agnes. Todos os direitos reservados.</p>
        </footer>
      </main>
    </div>
  );
}
